var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('div', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "accordion"
  }, [_c('b-card', {
    ref: "label-scan",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('label-scan')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("SCAN LABEL")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-label-scan",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_vm.dispatchRequest === null ? _c('label-scan', {
    attrs: {
      "location": _vm.location
    },
    on: {
      "success": _vm.finishScanLabel
    }
  }) : _vm.dispatchRequest === false ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "fade": "",
      "variant": "warning"
    }
  }, [_vm._v(" Er is geen retourzending gevonden voor deze barcode. Leg de producten in deze order apart, of probeer het opnieuw. ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.dispatchRequest = null;
      }
    }
  }, [_vm._v("Volgende")])], 1) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    ref: "product-scan",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('product-scan')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("SCAN ARTIKEL")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-product-scan",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3",
    attrs: {
      "data-sample-ean": _vm.sampleEan
    }
  }, [_vm.productEan === null ? _c('product-scan-return', {
    key: _vm.currentStep,
    on: {
      "success": _vm.finishScanProduct
    }
  }) : _vm.productEan === false ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "fade": "",
      "variant": "warning"
    }
  }, [_vm._v(" Dit product is niet gevonden in deze retourzending. Leg het product apart, of "), _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        _vm.productEan = null;
      }
    }
  }, [_vm._v("probeer het opnieuw")]), _vm._v(". ")], 1), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.setActiveStep('choose-next-step');
      }
    }
  }, [_vm._v("Volgende")])], 1) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    ref: "check-sellable",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('check-sellable')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("STAAT ARTIKEL")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-check-sellable",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_vm.productEan ? _c('check-sellable', {
    key: _vm.currentStep,
    attrs: {
      "process-type": _vm.processType,
      "location-identifier": _vm.location.identifier,
      "location-type-identifier": _vm.location.location_type.identifier,
      "storage-zone-identifier": _vm.storageZoneIdentifier,
      "product-ean": _vm.productEan
    },
    on: {
      "success": _vm.finishProductStateStep
    }
  }) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    ref: "sorting-location-scan",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('sorting-location-scan')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("SCAN LEGPLAATS")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-sorting-location-scan",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_vm.sortingLocation && _vm.dispatchRequest ? _c('sorting-location-scan', {
    key: _vm.currentStep,
    attrs: {
      "storage-location-display-name": _vm.sortingLocation.display_name,
      "storage-location-identifier": _vm.sortingLocation.identifier,
      "dispatch-request": _vm.dispatchRequest,
      "product-identifier": _vm.productEan,
      "process-type": _vm.processType,
      "location": _vm.location,
      "storage-zone-identifier": _vm.storageZoneIdentifier,
      "product-state": _vm.productState
    },
    on: {
      "success": _vm.finishSortingLocationScan
    }
  }) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    ref: "choose-next-step",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('choose-next-step')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("VOLGENDE")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-choose-next-step",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "d-block w-100 mb-4",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.resetSteps();
      }
    }
  }, [_vm._v("Volgende retourzending")]), _vm.dispatchRequest ? _c('b-button', {
    staticClass: "d-block w-100",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.resetToProductScanStep();
      }
    }
  }, [_vm._v("Scan een ander product uit dezelfde retourzending")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }